import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FavoriteListComponent } from 'src/app/components/favorite-list/favorite-list.component';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { SuccessfullyActionComponent } from '../successfully-action/successfully-action.component';
import { PasarelaPagoComponent } from 'src/app/pages/vista-compra/components-compra/pasarela-pago/pasarela-pago.component';
import { FormComponentComponent } from 'src/app/components/form-component/form-component.component';
import { GiftCardService } from 'src/app/services/gift-card.service';
import { NavController } from '@ionic/angular';
import { StorageService } from 'src/app/services/storage.service';
import { Types } from 'src/app/constants/gift-card-type';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss'],
})
export class TransactionComponent implements OnInit, OnDestroy {
  @ViewChild('formComponent') formComponent: FormComponentComponent;
  @Output() public scrollToTop = new EventEmitter();
  @Input() type: string;
  public users: any[] = [];
  private _domainId = environment.domainId;
  private delay = undefined;
  public loading = false;
  public msgNoData = false;
  public fieldForm = undefined;
  public userSelected: any = undefined;
  public isFavorite = false;
  public uri = this.route.snapshot.queryParamMap.get('uri');
  public savedForm = undefined;
  private user: any = undefined;
  public hiddeSearchbar = false;
  public email: string = undefined;
  public files: string = undefined;
  private _giftCardAmount = 0;
  private _usersIndex = [];

  get giftCardSv() {
    return this._giftCardSv;
  }

  constructor(
    private httpSv: HttpService,
    private formSv: FormServices,
    private uiSv: UiServices,
    private loginSv: LoginService,
    private route: ActivatedRoute,
    private _giftCardSv: GiftCardService,
    private _navCtrl: NavController,
    private _storageSv: StorageService
  ) {}

  async getParams() {
    let ui: any = this.route.snapshot.queryParamMap.get('ui');
    ui = Number(ui);
    this.type = this.route.snapshot.queryParamMap.get('uri');
    if (ui) {
      if (!this._usersIndex.length) {
        const res: any = await this.httpSv.itemIndex('favorite');
        this._usersIndex = res.data;
      }
      const user = this._usersIndex.find((item) => item.user.id === ui);
      this.user = user.user;
      this.user.favorite = true;
      if (user && !this.uri) {
        this.setClient(this.user);
      }
    }
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.back(false);
    this.uri = undefined;
  }

  async searchUsers(user: string) {
    try {
      if (user.length > 2) {
        if (this.delay) {
          clearTimeout(this.delay);
        }
        this.loading = true;
        this.msgNoData = false;
        this.users = [];
        this.delay = setTimeout(async () => {
          const res: any = await this.httpSv.itemIndex(
            'favorite/search',
            `${user}/${this._domainId}`
          );
          this.users = res.data;
          if (!this.users.length) {
            this.msgNoData = true;
          } else {
            this.msgNoData = false;
          }
          this.loading = false;
        }, 500);
      } else {
        this.users = [];
        this.msgNoData = false;
      }
    } catch (err) {
      console.error(err);
    }
  }

  async showFavorites() {
    const { data } = await this.uiSv.showModal(FavoriteListComponent, {
      domainId: this._domainId,
    });
    if (data) {
      this.setClient(data);
    }
  }

  async setFavorite() {
    try {
      const action = this.userSelected.favorite ? 'destroy' : 'add';
      await this.httpSv.itemAction(
        { id: this.userSelected.id },
        'favorite',
        action
      );
      this.userSelected.favorite = !this.userSelected.favorite;
    } catch (err) {
      console.error(err);
    }
  }

  async setClient(user) {
    try {
      this.email = undefined;
      this.users = [];
      this.userSelected = user;
      this.msgNoData = false;
      const res: any[] = await this.formSv.getForm(
        'transaction',
        this._domainId
      );
      if (this._giftCardSv.giftCard) {
        for (const item of res) {
          item.fieldName === 'amount' && (item.disable = 1);
          break;
        }
      }
      this.fieldForm = res;
      if (this.type) {
        setTimeout(() => {
          this.formComponent.dinamicForm.get('amount').disable();
        });
      }
      if (this._giftCardSv.giftCard) {
        this._giftCardSv.giftCard = this._giftCardSv.giftCard.filter(
          (card) => card.counter
        );
        const files = this._giftCardSv.giftCard.map((item) => {
          return item.file;
        });
        this.files = files.join(',');

        this._giftCardSv.giftCard.map((item) => {
          this._giftCardAmount += (item.salePrice || item.price) * item.counter;
        });
        this.savedForm = { amount: this._giftCardAmount };
      }
    } catch (err) {
      console.error(err);
    }
  }

  async back(navigate = true) {
    this.uri = this.type;
    this.savedForm = undefined;
    this._giftCardSv.giftCard = undefined;
    this._giftCardSv.client = undefined;
    this._storageSv.removeLocalStorage('giftCard');
    this.fieldForm = undefined;
    this.userSelected = undefined;
    this.hiddeSearchbar = undefined;
    if (navigate) {
      if (this.type) {
        await this._navCtrl.navigateRoot('/buy-gift-cards', {
          queryParams: {
            isCoupon: Types.GIFT_CARD,
          },
        });
      } else {
        this._navCtrl.back();
      }
    }
  }

  async sendTransaction(data: FormData) {
    try {
      await this.uiSv.showLoading();
      this.email && data.set('email', this.email);
      let type = this.route.snapshot.queryParamMap.get('uri');
      if (type === 'giftCard/all' || type === 'coupon/all') {
        type = 'giftCard';
        data.set('buyGiftCard', Types.GIFT_CARD);
      } else {
        type = 'transfer';
      }

      if (type === 'giftCard') {
        data.append('amount', this._giftCardAmount.toString());
      }

      if (this._giftCardSv.giftCard) {
        const selectedGiftCard = this._giftCardSv.giftCard
          .filter((x) => x.counter)
          .map((item) => {
            return {
              file: item.file,
              price: item.price,
              id: item.id,
              quantity: item.counter,
              percentage: item.percentage,
            };
          });
        const normalizedArr = [];
        selectedGiftCard.forEach((item) => {
          for (let index = 0; index < item.quantity; index++) {
            normalizedArr.push(item);
          }
        });

        data.set('selectedGiftCard', JSON.stringify(normalizedArr));
      }
      const res: any = await this.httpSv.doTransaction(
        data,
        type,
        this.loginSv.user.id,
        this.userSelected?.id
      );
      await this.uiSv.loading.dismiss();
      if (res.status) {
        if (this._giftCardSv.giftCard) {
          const { data } = await this.uiSv.showModal(
            PasarelaPagoComponent,
            {
              goPayment: true,
              data: res.data,
              transactionData: res.data,
              showGiftCards: false,
            },
            'pasarela-pago'
          );

          if (data?.text !== 'sended') {
            return false;
          }
        }

        await this.uiSv.showModal(
          SuccessfullyActionComponent,
          {},
          'successComponent'
        );
        this.fieldForm = undefined;
        this.userSelected = undefined;
      } else {
        await this.uiSv.showToast(res.data);
      }
      this.back();
    } catch (err) {
      await this.uiSv.loading.dismiss();
      console.error(err);
    }
  }
}
